import $ from 'jquery';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import * as navigation from 'Navigation';
import StorableResultsTabState from 'results/linked-results/StorableResultsTabState';

import * as GridDAO from '../GridDAO';
import GridContentsTabState from './GridContentsTabState';
import GridFileState from './GridFileState';
import GridMetadataTabState from './GridMetadataTabState';
import PlateTabState from './PlateTabState';

export default class PlateFileState extends GridFileState {
  static fileType: string;
  static override openFile: (fileId: string) => JQueryPromise<unknown>;

  override editURL(): string {
    return GridDAO.plateEditorURL(this.id);
  }

  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  override initialize(...args: Array<any>): void {
    super.initialize(...args);
    this.changeListener = this.changeListener.bind(this);
    this.registerListeners();

    const buffers = new navigation.BufferStates([new navigation.BufferState(), new navigation.BufferState()]);
    this.set({buffers});
    const plateTabState = new PlateTabState({gridId: this.id});
    buffers.at(0).add(plateTabState);
    plateTabState.set({active: true});

    const contentsTabState = new GridContentsTabState({gridId: this.id});
    const secondaryTabs = [contentsTabState, new GridMetadataTabState({gridId: this.id})];
    buffers.at(1).add(secondaryTabs);
    contentsTabState.set({active: true});

    if (this.hasResults()) {
      buffers.at(1).add(new StorableResultsTabState({storableId: this.id}));
    }

    this.initIsWorkspaceSplitFromPreference();
  }
}

PlateFileState.fileType = ModelTypeConstants.PLATE;

PlateFileState.openFile = (fileId) =>
  $.Deferred()
    .resolve(new PlateFileState({id: fileId}))
    .promise();
